import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';

import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalBuilderService {
  data$: Subject<unknown>;
  afterModalOpen : BehaviorSubject<unknown>
  constructor(private modalService : NzModalService ) {
    this.data$ = new Subject<unknown>();
    this.afterModalOpen = new BehaviorSubject<unknown>(null);
  }

  /**
   *
   * @param modalContent  //The drawer body content
   * @param modalTitle  .//The title for Drawer.
   * @param modalParams // //The component inputs the param / The Template context
   */
  openModalForm(modalContent: any ,modalParams? :object , modalTitle? :string,width?:number , extraData?:string,  showFooter : boolean = true) {
    const modalRef = this.modalService.create({
      nzTitle: modalTitle,
      nzContent: modalContent ,
      nzData: modalParams,
      nzWidth:width,
      nzFooter: showFooter ?[
        {
          label: 'Close',
          onClick: componentInstance => {
            this.closeAll();
          }
        }
      ] : []
    })

    modalRef.afterOpen.subscribe(() => {
      this.afterModalOpen.next(extraData)
    });

    modalRef.afterClose.subscribe(data => {
      this.data$.next(data)
    });
    return this.data$;
  }

  closeAll(){
    this.modalService.closeAll();
  }


}
